module.exports = __webpack_public_path__ + "img/enterpreneuship_2.cd88c2bb.jpg";